import { useQuery } from '@tanstack/react-query';
import { SourcingList, SourcingSavedSearch } from '../../schemas/SourcingList.schema';
import { getSourcingListsAndSavedSearches } from '../../services/queries/SourcingListsQueries';
import { SOURCING_LISTS_KEY } from '../../services/queries-hooks/SourcingListsQueriesHooks';

interface ISourcingListsCache {
  lists: Pick<SourcingList, 'id' | 'name'>[];
  savedSearches: Pick<SourcingSavedSearch, 'id' | 'name'>[];
}

/**
 * The name the sidebar shows for this list or saved search, read from the cache the sidebar already filled.
 * `enabled: false` follows the cache without ever fetching, so a frosted module still makes no requests of its own.
 */
export function useSourcingListName(id: string | undefined, savedSearch: boolean): string | undefined {
  const { data } = useQuery<ISourcingListsCache>({
    queryKey: [SOURCING_LISTS_KEY],
    queryFn: getSourcingListsAndSavedSearches,
    enabled: false,
  });
  if (!id) {
    return undefined;
  }
  const items = savedSearch ? data?.savedSearches : data?.lists;
  return items?.find((item) => item.id === id)?.name;
}
